import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { AnimalGroupInfo } from "../GQLCalls/getAnimalGroupCall";

export type AnimalGroupItem = DynamicDataObk<AnimalGroupInfo[]>

const animalGroupDataAdapter = createEntityAdapter({
  selectId: (item: AnimalGroupItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AnimalGroupItem, string>, {con, data}: AnimalGroupItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "animal_group_id")
    data.forEach((entry) => dataDictionary[entry.animal_group_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      animalGroupDataAdapter.upsertOne(state, newPayload);
    }
  } else { animalGroupDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<AnimalGroupItem, string>, {con, data}: DynamicDataObk<Number[]>) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const newPayload = {con, data: state.entities[identifier].data.filter((animal) => !data.includes(animal.animal_group_id))}
    animalGroupDataAdapter.upsertOne(state, newPayload);
  }
}

const animalGroupsSlice = createSlice({
  name: "animalGroups",
    initialState: animalGroupDataAdapter.getInitialState<AnimalGroupItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<AnimalGroupItem>) => {
          mergePayloadAndState(state, payload);
        },
        delete: (state, {payload}) => {
          removeDeletedFromState(state,payload);
        }
    }
})

export const animalGroupActions = animalGroupsSlice.actions;
export default animalGroupsSlice.reducer;